/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Submitbutton1Inputs */

const en__field_submitbutton1 = /** @type {(inputs: _Field_Submitbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Register`)
};

const de__field_submitbutton1 = /** @type {(inputs: _Field_Submitbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

/**
* | output |
* | --- |
* | "Register" |
*
* @param {_Field_Submitbutton1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_submitbutton1 = /** @type {((inputs?: _Field_Submitbutton1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Submitbutton1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_submitbutton1(inputs)
	return de__field_submitbutton1(inputs)
});
export { _field_submitbutton1 as "_field_submitButton" }